export default "__VITE_PUBLIC_ASSET__a3ae8bac__"